import { Grid, useTheme, } from "@mui/material"
import { SkeletonCardAvatar } from "components/skeleton/SkeletonCardAvatar"

import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { useTranslation } from "react-i18next"
import { faCalendarCheck, faCalendarClock, faCalendarXmark } from "@fortawesome/pro-solid-svg-icons"
import { DashboardCard } from "../dashboard/DashboardCard/DashboardCard"
interface InspectionSoonCardProps {
  status: any
  icon: IconProp
  data: {
    booked: number
    unbooked: number
  }
}

export const InspectionSoonCard = ({ status, icon, data }: InspectionSoonCardProps) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <>
      <DashboardCard
        icon={faCalendarClock}
        itemLength={data.unbooked + data.booked}
        title={t("vehicleregistry.inspections_within_14_days", "Inspections within 14 days")}
        quantityType={t("global.pc", "pcs")}
        status={status}
      />
      <DashboardCard
        icon={faCalendarXmark}
        itemLength={data.unbooked}
        title={t("global.not_booked", "Not booked")}
        quantityType={t("global.pc", "pcs")}
        status={status}
        backgroundColor={(theme.palette as any).red[200]}
        iconColor={(theme.palette as any).red[900]}
      />
      <DashboardCard
        icon={faCalendarCheck}
        itemLength={data.booked}
        title={t("global.booked", "Booked")}
        quantityType={t("global.pc", "pcs")}
        status={status}
        backgroundColor={(theme.palette as any).green[200]}
        iconColor={(theme.palette as any).green[900]}
      />
    </>
  )
}
